/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Jobticketkuendigungsdatum3Inputs */



/**

* @param {_Field_Jobticketkuendigungsdatum3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_jobticketkuendigungsdatum3 = /** @type {((inputs?: _Field_Jobticketkuendigungsdatum3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Jobticketkuendigungsdatum3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Jobticket Kündigungs Datum")
});
export { _field_jobticketkuendigungsdatum3 as "_field_jobTicketKuendigungsDatum" }